import React from 'react'

const Beneficios = () => {
  return (
    <section className="text-gray-800 bg-white body-font border-t border-gray-200">
      <div className="container px-5 py-24 mx-auto flex flex-wrap items-center">
        <div className="lg:w-1/2 w-full mb-12 lg:mb-0 rounded-lg overflow-hidden shadow-xl">
          <img
            alt="Visualización"
            className="object-cover object-center h-full w-full"
            src="https://images.unsplash.com/photo-1611926653458-09294b3142bf?auto=format&fit=crop&w=1170&q=80"
          />
        </div>
        <div className="lg:w-1/2 w-full lg:pl-16">
          <div className="space-y-10">
            {/* Beneficio 1 */}
            <BeneficioItem
              titulo="Reportes y Estadísticas"
              descripcion="Mostramos resultados medibles mediante informes y métricas clave."
              icono={
                <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
              }
            />
            {/* Beneficio 2 */}
            <BeneficioItem
              titulo="Herramientas Profesionales"
              descripcion="Usamos plataformas especializadas para alcanzar objetivos concretos."
              icono={
                <>
                  <circle cx="6" cy="6" r="3" />
                  <circle cx="6" cy="18" r="3" />
                  <path d="M20 4L8.12 15.88M14.47 14.48L20 20M8.12 8.12L12 12" />
                </>
              }
            />
            {/* Beneficio 3 */}
            <BeneficioItem
              titulo="Enfocados en el Cliente"
              descripcion="Nos comprometemos con el éxito y crecimiento de cada marca que confía en nosotros."
              icono={
                <>
                  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </>
              }
            />
            {/* Beneficio 4 NUEVO */}
            <BeneficioItem
              titulo="Diseño Personalizado"
              descripcion="Cada proyecto se adapta a las necesidades y estilo de tu marca."
              icono={
                <path d="M12 2l4 8H8l4-8zm0 20l-4-8h8l-4 8z" />
              }
            />
            {/* Beneficio 5 NUEVO */}
            <BeneficioItem
              titulo="Soporte Continuo"
              descripcion="Te acompañamos antes, durante y después para garantizar resultados sostenibles."
              icono={
                <>
                  <path d="M18 13a6 6 0 00-12 0" />
                  <circle cx="12" cy="13" r="3" />
                </>
              }
            />
          </div>
        </div>
      </div>
    </section>
  )
}

// Componente reutilizable para cada ítem
const BeneficioItem = ({ titulo, descripcion, icono }) => (
  <div className="flex items-start">
    <div className="w-14 h-14 flex-shrink-0 inline-flex items-center justify-center rounded-full bg-gradient-to-r from-cyan-200 via-blue-300 to-blue-500 text-white">
      <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
        className="w-6 h-6" viewBox="0 0 24 24">
        {icono}
      </svg>
    </div>
    <div className="ml-6">
      <h3 className="text-lg font-semibold mb-1">{titulo}</h3>
      <p className="text-gray-600">{descripcion}</p>
    </div>
  </div>
)

export default Beneficios
